module.exports = __webpack_public_path__ + "img/6.b089307c.png";